'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var FormControl = require('@mui/material/FormControl');
var FormLabel = require('@mui/material/FormLabel');
var MuiRadioGroup = require('@mui/material/RadioGroup');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var FormControl__default = /*#__PURE__*/_interopDefaultLegacy(FormControl);
var FormLabel__default = /*#__PURE__*/_interopDefaultLegacy(FormLabel);
var MuiRadioGroup__default = /*#__PURE__*/_interopDefaultLegacy(MuiRadioGroup);

var StyledFormControl = styled__default["default"](FormControl__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject([""], [""])));
var StyledFormLabel = styled__default["default"](FormLabel__default["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  &.Mui-focused {\n    color: ", ";\n  }\n  font-family: ", ";\n  color: ", ";\n"], ["\n  &.Mui-focused {\n    color: ", ";\n  }\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var primary = _a.theme.fonts.primary;
    return primary;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var StyledRadioGroup = styled__default["default"](MuiRadioGroup__default["default"])(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-top: 5px;\n  padding-top: 5px;\n"], ["\n  margin-top: 5px;\n  padding-top: 5px;\n"])));
var RadioGroup = React__default["default"].forwardRef(function (_a, ref) {
    var className = _a.className, name = _a.name, _b = _a.value, value = _b === void 0 ? '' : _b, label = _a.label, children = _a.children, onChange = _a.onChange, _c = _a.displayRow, displayRow = _c === void 0 ? false : _c;
    return (React__default["default"].createElement(StyledFormControl, { className: className },
        React__default["default"].createElement(StyledFormLabel, null, label),
        React__default["default"].createElement(StyledRadioGroup, { name: name, value: value, onChange: function (event) {
                return onChange && onChange(event.target.value);
            }, ref: ref, row: displayRow }, React__default["default"].Children.map(children, function (radio_button) {
            return React__default["default"].isValidElement(radio_button)
                ? React__default["default"].cloneElement(radio_button, {
                    key: radio_button.props.value,
                    checked: value === radio_button.props.value,
                })
                : null;
        }))));
});
var templateObject_1, templateObject_2, templateObject_3;

exports["default"] = RadioGroup;
